import * as React from "react";
import { render } from "react-dom";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import {
    fetchSubmissionsForKitRegistration, fetchKitData,
    fetchSubmissionStatus, downloadProjectResults, downloadProjectAllData
} from "../utility";
import { FaDownload } from 'react-icons/fa'
import { FaShare } from "react-icons/fa"



export default function ProjectResultGenerator() {
    const KIT_REGISTRATION_ID = window.location.pathname.split("/")[2];
    const [submissions, setSubmissions] = React.useState([]);
    const [assay, setAssay] = React.useState(null);
    const [selectedPanels, setSelectedPanels] = React.useState({
        "panel_a": {},
        "panel_b": {},
        "dfi_1": {},
        "dfi_2": {},
    })

    React.useEffect(() => {

        fetchKitData(KIT_REGISTRATION_ID)
            .then((kitData) => {
                console.log("kit data:", kitData)
                if (submissions.length <= 0) {
                    fetchSubmissionsForKitRegistration(KIT_REGISTRATION_ID)
                        .then((data) => {
                            console.log("all submisisons:", data)
                            setAssay(kitData.assay)
                            if (kitData.assay == 'GIGA') {
                                setSelectedPanels({
                                    ...selectedPanels,
                                    "dfi_3": {},
                                    "dfi_4": {},
                                })
                            }
                            data = data.filter((submission) => submission.in_profiling_stage || submission.is_fia)
                            console.log("DATA:::", data)
                            setSubmissions(data)
                            setSelectedPanels({
                                "panel_a": data.filter((submission) => submission.panel === "Panel_A")[0],
                                "panel_b": data.filter((submission) => submission.panel === "Panel_B")[0],
                                "dfi_1": data.filter((submission) => submission.panel === "DFI_1")[0],
                                "dfi_2": data.filter((submission) => submission.panel === "DFI_2")[0],
                                "dfi_3": data.filter((submission) => submission.panel === "DFI_3")[0],
                                "dfi_4": data.filter((submission) => submission.panel === "DFI_4")[0],
                            })
                        })
                }
            })

    }, []);

    React.useEffect(() => {
        console.log("Selected panels:", selectedPanels)
    }, [selectedPanels])

    return (
        <div style={{ margin: '0' }}>
            <div className="btn-group">
                <button className="btn dropdown-toggle dropdown-toggle-split prg-toggle-btn" data-bs-auto-close="outside" data-bs-toggle="dropdown" aria-expanded="false">
                    <span className="visually-hidden">Toggle Dropdown</span>
                </button>
                <div className="dropdown-menu prg-dropdown-menu shadow-lg">
                    <PanelChoiceItem
                        panelName="Panel A"
                        panelSubmissions={submissions.filter((submission) => submission.panel === "Panel_A")}
                        setSelectedPanels={setSelectedPanels}
                        selectedPanels={selectedPanels}
                    />
                    <div className="prg-divider"></div>
                    <PanelChoiceItem
                        panelName="Panel B"
                        panelSubmissions={submissions.filter((submission) => submission.panel === "Panel_B")}
                        setSelectedPanels={setSelectedPanels}
                        selectedPanels={selectedPanels}
                    />
                    <div className="prg-divider"></div>
                    <PanelChoiceItem
                        panelName="DFI 1"
                        panelSubmissions={submissions.filter((submission) => submission.panel === "DFI_1")}
                        setSelectedPanels={setSelectedPanels}
                        selectedPanels={selectedPanels}
                    />
                    <div className="prg-divider"></div>
                    <PanelChoiceItem
                        panelName="DFI 2"
                        panelSubmissions={submissions.filter((submission) => submission.panel === "DFI_2")}
                        setSelectedPanels={setSelectedPanels}
                        selectedPanels={selectedPanels}
                    />
                    {
                        assay === "GIGA" &&
                        <>
                            <div className="prg-divider"></div>
                            <PanelChoiceItem
                                panelName="DFI 3"
                                panelSubmissions={submissions.filter((submission) => submission.panel === "DFI_3")}
                                setSelectedPanels={setSelectedPanels}
                                selectedPanels={selectedPanels}
                            />
                            <div className="prg-divider"></div>
                            <PanelChoiceItem
                                panelName="DFI 4"
                                panelSubmissions={submissions.filter((submission) => submission.panel === "DFI_4")}
                                setSelectedPanels={setSelectedPanels}
                                selectedPanels={selectedPanels}
                            />
                        </>

                    }
                    <div className="prg-divider"></div>
                    <div className="d-flex flex-column gap-2 p-3">
                        <button className="prg-action-btn prg-btn-download" id="download-btn"
                            onClick={() => {
                                downloadProjectResults(KIT_REGISTRATION_ID, selectedPanels["panel_a"]?.id, selectedPanels["panel_b"]?.id, selectedPanels["dfi_1"]?.id, selectedPanels["dfi_2"]?.id, sendToMetaboanalyst = false, selectedPanels["dfi_3"]?.id, selectedPanels["dfi_4"]?.id)
                                    .then((data) => {
                                        // make spinner visible
                                        document.getElementById('download-icon').classList.add('d-none')
                                        document.getElementById('download-spinner').classList.remove('d-none')
                                        document.getElementById('download-btn').disabled = true

                                        let pollProgress = setInterval(() => {
                                            fetch(`/stats/report_progress?kit_id=${KIT_REGISTRATION_ID}`)
                                                .then((response) => response.json())
                                                .then((data) => {
                                                    console.log("progress data:", data)
                                                    let progressElement = document.getElementById('download-progress')
                                                    progressElement.classList.remove('d-none')
                                                    progressElement.innerText = `${data.progress}%`
                                                    if (data.status === 'completed') {
                                                        progressElement.classList.add('d-none')
                                                        progressElement.innerText = ""
                                                        const url = `/get_generated_report?report_id=${encodeURIComponent(data.report_id)}`
                                                        window.location.assign(url)
                                                        document.getElementById('download-icon').classList.remove('d-none')
                                                        document.getElementById('download-spinner').classList.add('d-none')
                                                        document.getElementById('download-btn').disabled = false
                                                        clearInterval(pollProgress)
                                                    } else if (data.status === 'errored') {
                                                        console.error('Error generating report');
                                                        document.getElementById('download-icon').classList.remove('d-none')
                                                        document.getElementById('download-spinner').classList.add('d-none')
                                                        document.getElementById('download-btn').disabled = false
                                                        document.getElementById('download-progress').classList.add('d-none')
                                                        clearInterval(pollProgress)
                                                    }
                                                })
                                        }, 2000)

                                    })
                            }}
                        >
                            <span className='align-sup spinner-border spinner-border-sm d-none mx-1' role='status' id='download-spinner' />
                            <span className='align-sup d-none mx-1' id='download-progress'></span>
                            <FaDownload className='align-sup mx-1' id='download-icon' /> Download Report
                        </button>

                        <button className="prg-action-btn prg-btn-download" id='download-all-btn'
                            onClick={() => {
                                downloadProjectAllData(KIT_REGISTRATION_ID, selectedPanels["panel_a"]?.id, selectedPanels["panel_b"]?.id, selectedPanels["dfi_1"]?.id, selectedPanels["dfi_2"]?.id, sendToMetaboanalyst = false, selectedPanels["dfi_3"]?.id, selectedPanels["dfi_4"]?.id)
                                    .then((data) => {
                                        // make spinner visible
                                        document.getElementById('download-all-icon').classList.add('d-none')
                                        document.getElementById('download-all-spinner').classList.remove('d-none')
                                        document.getElementById('download-all-btn').disabled = true

                                        let pollProgress = setInterval(() => {
                                            fetch(`/stats/report_progress?kit_id=${KIT_REGISTRATION_ID}`)
                                                .then((response) => response.json())
                                                .then((data) => {
                                                    console.log("progress data:", data)
                                                    let progressElement = document.getElementById('download-progress-all')
                                                    progressElement.classList.remove('d-none')
                                                    progressElement.innerText = `${data.progress}%`
                                                    if (data.status === 'completed') {
                                                        progressElement.classList.add('d-none')
                                                        progressElement.innerText = ""
                                                        const url = `/get_generated_report?report_id=${encodeURIComponent(data.report_id)}`
                                                        window.location.assign(url)
                                                        document.getElementById('download-all-icon').classList.remove('d-none')
                                                        document.getElementById('download-all-spinner').classList.add('d-none')
                                                        document.getElementById('download-all-btn').disabled = false
                                                        clearInterval(pollProgress)
                                                    } else if (data.status === 'errored') {
                                                        console.error('Error generating all data report');
                                                        document.getElementById('download-all-icon').classList.remove('d-none')
                                                        document.getElementById('download-all-spinner').classList.add('d-none')
                                                        document.getElementById('download-all-btn').disabled = false
                                                        document.getElementById('download-progress-all').classList.add('d-none')
                                                        clearInterval(pollProgress)
                                                    }

                                                })

                                        }, 2000)



                                    })
                                    .catch((error) => {
                                        console.error('Error downloading all data:', error);
                                        document.getElementById('download-all-icon').classList.remove('d-none')
                                        document.getElementById('download-all-spinner').classList.add('d-none')
                                        document.getElementById('download-all-btn').disabled = false
                                    })
                            }}
                        >
                            <span className='align-sup d-none mx-1' id='download-progress-all'></span>
                            <div className='align-sup spinner-border spinner-border-sm d-none mx-1' role='status' id='download-all-spinner' />
                            <FaDownload className='align-sup mx-1' id='download-all-icon' /> Download All Data
                        </button>

                        <button className="prg-action-btn prg-btn-send" id="metaboanalyst-btn"
                            onClick={() => {
                                console.log("clicked")
                                document.getElementById('send-icon').classList.add('d-none')
                                document.getElementById('send-spinner').classList.remove('d-none')
                                document.getElementById('metaboanalyst-btn').disabled = true

                                downloadProjectResults(KIT_REGISTRATION_ID, selectedPanels["panel_a"]?.id, selectedPanels["panel_b"]?.id, selectedPanels["dfi_1"]?.id, selectedPanels["dfi_2"]?.id, sendToMetaboanalyst = true)
                                    .then((data) => {
                                        console.log("downloaded", data.csv_string)
                                        // let csv_string = data.csv_string
                                        // // create csv file and download
                                        // let blob = new Blob([csv_string], {type: 'text/csv'})
                                        // let link = document.createElement('a')
                                        // link.href = window.URL.createObjectURL(blob)
                                        // let projectName = document.getElementById('project-name').innerText
                                        // link.download = `LC-Autofit-${projectName}-results.csv`
                                        // link.click()
                                        document.getElementById('send-icon').classList.remove('d-none')
                                        document.getElementById('send-spinner').classList.add('d-none')
                                        document.getElementById('metaboanalyst-btn').disabled = false
                                        window.location = "https://www.metaboanalyst.ca/MetaboAnalyst/upload/StatUploadView.xhtml"
                                    })
                                // // window.location = https://www.metaboanalyst.ca/MetaboAnalyst/upload/StatUploadView.xhtml
                                // concentrationsCSVString = "test1, test2\n1, 2\n3, 4\n"
                                // fetch("https://34.121.27.8:80/MetaboAnalyst-5.0/Secure/api.xhtml", {
                                //     mode: 'no-cors',
                                //     method: 'GET',
                                //     body: concentrationsCSVString,
                                // })
                                // .then((response) => console.log(response))
                            }}
                        >
                            <div className="spinner-border spinner-border-sm d-none mx-1" role="status" id='send-spinner' />
                            <FaShare id='send-icon' /> Send to MetaboAnalyst</button>
                    </div>
                </div>
                <button data-bs-toggle="dropdown" className="prg-analyse-btn"><i className="bi bi-graph-up-arrow me-1"></i>Analyse Concentrations</button>
            </div>
        </div>
    )
}

function PanelChoiceItem(props) {

    let panelKey = props.panelName.toLowerCase().replace(" ", "_")
    console.log('panel submissions', props.panelSubmissions, panelKey)
    return (
        <div className="prg-panel-section">
            <h6 className="prg-panel-title">Select submission for {`${props.panelName}`}:</h6>
            <div className="dropdown w-100">
                <button className={`prg-panel-selector w-100 ${props.selectedPanels[panelKey] ? "prg-panel-selected" : "prg-panel-empty"}`} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    {`${props.panelSubmissions.length > 0 ?
                        `${props.selectedPanels[panelKey].id} | ${props.selectedPanels[panelKey].name} | ${props.selectedPanels[panelKey].status} | ${props.selectedPanels[panelKey].num_exp_samples}`
                        : "No submissions found."}`}
                </button>
                <div className="dropdown-menu prg-panel-dropdown w-100">
                    <table className="prg-panel-table w-100">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Status</th>
                                <th># Exp. Samples</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                props.panelSubmissions.filter((s) => (s.in_profiling_stage || s.is_fia)).map((submission) => {
                                    return (
                                        <tr key={`option-${submission.id}`} className="border-bottom"
                                            style={{ cursor: 'pointer' }}
                                            onClick={(e) => {
                                                console.log("clicked", submission)
                                                props.setSelectedPanels({
                                                    ...props.selectedPanels,
                                                    [`${props.panelName.toLowerCase().replace(" ", "_")}`]: submission
                                                })
                                            }}
                                        >
                                            <td>{submission.id}</td>
                                            <td>{submission.name}</td>
                                            <td>{submission.status}</td>
                                            <td>{submission.num_exp_samples}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}